exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".week-nav-btn {\n  font-size: 20px;\n  margin-top: 1px; }\n\n.card-header-right-button {\n  margin-left: auto; }\n\n.header-mi-evolucion {\n  padding-bottom: 12px;\n  padding-top: 12px; }\n\n.consignas-de-hoy-card {\n  height: 100%; }\n\n.view-all {\n  position: absolute;\n  bottom: 0;\n  width: 100%; }\n\n.dashboard-row {\n  height: 400px; }\n\n.dashboard-card-full-column {\n  height: 390px; }\n\n.profile-picture {\n  height: 40px;\n  width: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/dashboard/dashboard.component.scss
// module id = ../../../../../src/app/components/dashboard/dashboard.component.scss
// module chunks = 0